import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export const InfoIcon = ({ text }: { text: string }) => {
  return (
    <Tooltip title={text}>
      <HelpIcon
        fontSize="inherit"
        style={{
          fontSize: "1.0em",
          verticalAlign: "super",
          marginLeft: 4,
          color: "green",
          cursor: "pointer",
        }}
      />
    </Tooltip>
  );
};